var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.9215 0.463867C1.30312 0.463867 0 1.76698 0 3.38537V13.5424C0 15.1607 1.30312 16.4639 2.9215 16.4639H8.42651V10.2089H6.77251V7.95686H8.42651V6.03286C8.42651 4.52127 9.40378 3.13337 11.655 3.13337C12.5665 3.13337 13.2405 3.22087 13.2405 3.22087L13.1875 5.32387C13.1875 5.32387 12.5001 5.31738 11.75 5.31738C10.9382 5.31738 10.808 5.69142 10.808 6.31238V7.95688H13.252L13.1455 10.2089H10.808V16.4639H13.0785C14.6969 16.4639 16 15.1607 16 13.5424V3.38538C16 1.767 14.6969 0.463883 13.0785 0.463883H2.92149L2.9215 0.463867Z","fill":"#0087E9"}));
}

FacebookIcon.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
